<template>
   <span>
        <div v-html="printResponse.show_content" class="hide-on-print"></div>
        <div v-html="printResponse.print_content" id="printContent"></div>
        <div class="hide-on-print pull-right">
              <v-btn color="primary" large dressed @click="print" class="hide-on-xs mr-2">Print</v-btn>
                          <v-btn color="secondary" large dressed @click="pdfDownload"
                                 class="mr-2">Download as pdf</v-btn>
                           <v-btn color="secondary" large dressed @click="moveToApplyAgain"
                                  class="mr-2">Apply again</v-btn>
        </div>
    </span>
</template>

<script>
    export default {
        name: "CertificationPrint",
        computed: {
            printResponse() {
                return this.$store.state.VisaSingle.printResponse;
            }
        },
        methods: {
            print() {
                window.print()
            },
            pdfDownload() {
                window.open(this.printResponse.pdf_url, "_blank");
            },
            moveToApplyAgain() {
                window.location.href = '/visa-processing';
            }
        }
    }
</script>

<style scoped>
    #printContent {
        display: none;
    }

    @media print {
        .hide-on-print {
            display: none;
        }

        #printContent {
            display: block;
        }
    }
</style>
